import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { GeneratedField } from 'src/pages/CompanyPage/_BLL/types';
import { Select } from 'src/shared/ui/_inputs/Select';
import { InfoTooltip } from 'src/shared/ui/_tooltips/InfoTooltip';
import s from './StringManyField.module.scss';

export const StringManyField: React.FC<GeneratedField> = (props) => {
	const {
		namePrefix, //
		propertyName,
		internalName,
		measureUnits,
		validate,
	} = props;

	// * Form
	const name = `${namePrefix}${propertyName}.${internalName}`;
	const { setValue, control } = useFormContext();

	const VALUES_NAME = `${name}.values`;

	const onChange = (values: string[]) => {
		if (values.length === 0) {
			setValue(VALUES_NAME, null);
		} else {
			setValue(VALUES_NAME, values);
		}
	};

	// * Component
	return (
		<Controller
			name={`${name}.values`}
			control={control}
			rules={{ validate: validate }}
			render={({ field, fieldState }) => (
				<div className={s.fieldWrapper}>
					<Select
						{...field}
						className={s.field}
						mode="tags"
						maxTagCount="responsive"
						onChange={onChange}
						tokenSeparators={[';']}
						placement="bottomLeft"
						size="middle"
						error={fieldState.error?.message}
					/>
					{measureUnits && <span className={s.additionalTextRight}>{measureUnits}</span>}

					{field.value && <InfoTooltip info={field.value.map((value: string | number) => value)} />}
				</div>
			)}
		/>
	);
};
